/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";

import styles from "./LoadingScreen.module.css";

export default function LoadingScreen(props: {
  message: string;
  lightMode?: boolean;
  top?: boolean;
  backgroundColor?: string;
}) {
  return (
    <div
      style={
        props.lightMode
          ? { backgroundColor: "#FFFFFA" }
          : props.backgroundColor
          ? { backgroundColor: props.backgroundColor }
          : {}
      }
      className={props.top ? styles.mainTop : styles.main}
    >
      <img
        width={50}
        height={50}
        alt=""
        className="loader"
        src={"/loader.png"}
      />
      <p style={props.lightMode ? { color: "#181716" } : {}}>{props.message}</p>
    </div>
  );
}

export function LoadingScreenWithMessages(props: { messages: string[] }) {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    if (props.messages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (prevIndex < props.messages.length - 1) {
          return prevIndex + 1;
        } else {
          clearInterval(interval);
          return prevIndex;
        }
      });
    }, 4000);

    return () => clearInterval(interval);
  }, [props.messages]);

  return (
    <div className={styles.main}>
      <img
        width={50}
        height={50}
        alt=""
        className="loader"
        src={"/loader.png"}
      />
      <p>{props.messages[currentIndex]}</p>
    </div>
  );
}
